import { z } from "zod";

/**
 * Admin Metrics 24h series (US-AE.F9 · @UC9099 dead-feature #6) — chuỗi mẫu metric vận hành 24h gần
 * nhất cho biểu đồ ở /metrics (thay bar số cứng). Nguồn: MetricsSnapshot do worker lấy mẫu mỗi 30'.
 * Metric THẬT worker-derivable = outbox lag (giây); errorRate/latency 0 (prom-client ở API, worker
 * không lấy) — FE hiện chart outbox lag. KHÔNG money/PII.
 */
export const metricsSnapshotPointSchema = z.object({
  at: z.string(), // ISO8601
  outboxLagSecs: z.number().int().nonnegative(),
  errorRate: z.number().nonnegative(),
  latencyP99Ms: z.number().int().nonnegative(),
});
export type MetricsSnapshotPoint = z.infer<typeof metricsSnapshotPointSchema>;

export const metricsSeriesResponseSchema = z.object({
  /** Điểm mẫu 24h gần nhất, cũ→mới (để vẽ trái→phải). Rỗng khi chưa có mẫu (worker chưa chạy). */
  points: z.array(metricsSnapshotPointSchema),
});
export type MetricsSeriesResponse = z.infer<typeof metricsSeriesResponseSchema>;
